module.exports = __webpack_public_path__ + "img/5-3.05fad3e3.svg";